import React, {useEffect, useRef, useState} from "react";
import {BasicProps} from "../Main";
import {useNavigate} from "react-router-dom";
import {Grid, MenuItem} from "@mui/material";
import {Colours, SamaggiTypography} from "../Components/SamaggiTypography";
import {SamaggiField, SamaggiSelect, SamaggiSlider} from "../Components/SamaggiFields";
import {SamaggiButton} from "../Components/SamaggiButton";
import {SamaggiFormSection} from "../Components/SamaggiForm";
import AWS from "aws-sdk";
import {v4 as UUIDv4} from "uuid";
import lanyardTemp from "../assets/lanyard template 125.png"
import axios from "axios";
import {handleError} from "../support";


export const Lanyard: React.FC<BasicProps> = (props) => {
    const navigate = useNavigate();

    const [firstLoad, setFirstLoad] = useState(true);

    const [file, setFile] = useState();
    const [filePreview, setFilePreview] = useState<string | undefined>(undefined)
    const [fileName, setFileName] = useState("");

    const [team, setTeam] = useState("");
    const [role, setRole] = useState("");
    const [nickname, setNickname] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");

    const [shirtSize, setShirtSize] = useState("")

    const [xOffset, setXOffset] = useState(0);
    const [yOffset, setYOffset] = useState(0);
    const [scale, setScale] = useState(100);
    const [xOffsetPct, setXOffsetPct] = useState(0);
    const [yOffsetPct, setYOffsetPct] = useState(0);

    const [submitText, setSubmitText] = useState("Submit");

    const inputRef = useRef(null);
    const previewInnerRef = useRef<HTMLDivElement>(null);

    async function uploadFile() {
        const bucketName = "lanyard-images-ss123";
        const bucketRegion = "eu-west-2";
        const IdentityPoolId = "eu-west-2:0fd5fe57-a07b-43bd-a383-0fea2bad6976";

        AWS.config.update({
            region: bucketRegion,
            credentials: new AWS.CognitoIdentityCredentials({
                IdentityPoolId: IdentityPoolId
            })
        });

        if (file === undefined) {
            alert("Please choose an image.");
            return
        }

        const re = /(?:\.([^.]+))?$/;
        const regex = re.exec(fileName)

        if (regex === null) {
            alert("Failed to get image name.")
            return
        }

        let fileExt = regex[1];

        if (fileExt === undefined) {
            fileExt = ".jpg";
        }

        const key = encodeURI(`${team}-${firstName}-${UUIDv4().toString().replaceAll("-", "").slice(0, 14)}.${fileExt}`);

        const upload = new AWS.S3.ManagedUpload({
            params: {
                Bucket: bucketName,
                Key: key,
                Body: file
            }
        });

        const uploadPromise = upload.promise();

        props.setShowCover(true);

        uploadPromise.then(
            () => submit(bucketName, key),
            function(err) {
                alert(err);
                props.setShowCover(false);
                return alert("There was an error uploading your photo: " + err.message);
            }
        );
    }

    function submit(bucket: string, key: string) {
        const token = localStorage.getItem("token");

        if (token === null) {
            alert("You're not signed in.")
            return
        }

        const data = {
            "token": token,
            "fileLink": key,
            "scale": scale,
            "xOffset": xOffsetPct,
            "yOffset": yOffsetPct,
            "size": shirtSize
        }

        axios.post("https://usvj99ipg7.execute-api.eu-west-2.amazonaws.com/Prod/lanyard/submit", data).then((res) => {
            console.log(res);
            props.setShowCover(false);

            alert("Submitted Successfully");

            navigate("/");
        }).catch((error) => {
            props.setShowCover(false);

            handleError(error);
        })
    }

    function load() {
        const ud = localStorage.getItem("userData");
        const token = localStorage.getItem("token");
        if (ud !== null) {
            const userData = JSON.parse(ud);
            setFirstName(userData.name.firstName);
            setLastName(userData.name.lastName);
            setNickname(userData.name.nickname);
            setRole(userData.role);
            setTeam(userData.team);
        }

        props.setShowCover(true);

        axios.post("https://usvj99ipg7.execute-api.eu-west-2.amazonaws.com/Prod/lanyard/init", {"token": token}).then((res) => {
            console.log(res);
            props.setShowCover(false);

            if (!res.data.data.open) {
                alert("Form no longer accepting responses.");
                navigate("/");
            }

            if (res.data.data.submitted) {
                alert("You have already submitted this form. If you submit again, your last response will be overwritten.");
                setSubmitText("Resubmit");
            }
        }).catch((error) => {
            props.setShowCover(false);
            // alert("Unable to load form.");

            handleError(error, true);
        })
    }

    function valChanged(type: string, val: number) {
        if (typeof filePreview === "string" && previewInnerRef.current !== null && previewInnerRef.current.clientWidth && previewInnerRef.current.clientHeight) {
            const image = new Image();
            image.src = filePreview;

            let lScale;

            if (image.height > image.width) {
                lScale = previewInnerRef.current.clientWidth / image.width
            } else {
                lScale = previewInnerRef.current.clientHeight / image.height
            }

            let cScale = scale;

            if (type === "s") {
                cScale = val;
            }

            const yMovementLimit = lScale * image.height * cScale/100 - previewInnerRef.current.clientHeight
            const xMovementLimit = lScale * image.width * cScale/100 - previewInnerRef.current.clientWidth

            if (type === "x") {
                setXOffsetPct(val);

                setXOffset(xMovementLimit * val/100)
            } else if (type === "y") {
                setYOffsetPct(val);

                setYOffset(yMovementLimit * val/100)
            } else if (type === "s") {
                setScale(val);

                setXOffset(xMovementLimit * xOffsetPct/100)
                setYOffset(yMovementLimit * yOffsetPct/100)
            }
        }
    }

    function handleFileChange(e: any) {
        e.preventDefault();
        if (e.target.files && e.target.files[0]) {
            setFile(e.target.files[0]);
            setFileName(e.target.files[0].name);
        }

        const reader = new FileReader();

        reader.onload = function (e) {
            if (e.target !== null && typeof e.target.result === "string") {
                setFilePreview(e.target.result);
                setXOffsetPct(0);
                setYOffsetPct(0);
                setXOffset(0);
                setYOffset(0);
            }
        }

        reader.readAsDataURL(e.target.files[0]);
    }


    useEffect(() => {
        if (firstLoad) {
            setFirstLoad(false);
            load();
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    return (
        <>
            <Grid container direction={"column"} spacing={4}>
                <Grid item container direction={"column"} spacing={1}>
                    <Grid item>
                        <SamaggiTypography bold large center>Samaggi Staff Lanyard and Shirt Form</SamaggiTypography>
                    </Grid>
                    <Grid item>
                        <SamaggiTypography center small>Please upload an image to preview your lanyard. Once you're happy with how your lanyard looks, you can submit it.</SamaggiTypography>
                    </Grid>
                </Grid>
                <Grid item container direction={"column"} spacing={3}>
                    <SamaggiFormSection label={"Personal Details"} direction={"column"} spacing={3}>
                        <Grid item container direction={"row"} spacing={2}>
                            <Grid item xs={12} md={6}>
                                <SamaggiField label={"First Name"} value={firstName} disabled/>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <SamaggiField label={"Last Name"} value={lastName} disabled/>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <SamaggiField label={"Nickname"} value={nickname} disabled/>
                        </Grid>
                        <Grid item container direction={"row"} spacing={2}>
                            <Grid item xs={12} md={6}>
                                <SamaggiField label={"Team"} value={team} disabled/>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <SamaggiField label={"Role"} value={role} disabled/>
                            </Grid>
                        </Grid>
                    </SamaggiFormSection>
                    <SamaggiFormSection label={"Staff Shirt Size"} direction={"column"} spacing={3}>
                        <Grid item>
                            <SamaggiTypography xsmall>Please indicate your shirt size below.</SamaggiTypography>
                        </Grid>
                        <Grid item container direction={"row"} alignContent={"center"}>
                            <img src={"https://general-assets-ss.s3.eu-west-2.amazonaws.com/size_guide_ss123.jpg"} style={{maxWidth: "80%", margin: "auto"}} alt={"Shirt Size Guide, Contact Marketing Team if you are visually impaired and is not able to read."}/>
                        </Grid>
                        <Grid item>
                            <SamaggiSelect label={"Shirt Size"} value={shirtSize} onChange={(e) => {setShirtSize(e.target.value as string)}} required>
                                <MenuItem value={"S"}>S</MenuItem>
                                <MenuItem value={"M"}>M</MenuItem>
                                <MenuItem value={"L"}>L</MenuItem>
                                <MenuItem value={"XL"}>XL</MenuItem>
                                <MenuItem value={"2XL"}>2XL</MenuItem>
                                <MenuItem value={"3XL"}>3XL</MenuItem>
                            </SamaggiSelect>
                        </Grid>
                    </SamaggiFormSection>
                    <SamaggiFormSection label={"Image Upload"} direction={"column"} spacing={3}>
                        <Grid item>
                            <SamaggiTypography xsmall>Please upload an image of yourself here. You should adjust (zoom/move) your image so that your face is clearly visible inside of the circular frame. Your face should take up approximately 70% of the frame and there should not be any other faces in the frame.</SamaggiTypography>
                        </Grid>
                        <Grid item container>
                            <input ref={inputRef} type="file" accept="image/png, image/jpeg" id="file-upload" onChange={(e) => {handleFileChange(e)}} />
                        </Grid>
                    </SamaggiFormSection>
                    <SamaggiFormSection label={"Preview"} direction={"column"} spacing={3}>
                        <Grid item>
                            <div style={{position: "relative"}}>
                                {filePreview !== undefined && <div ref={previewInnerRef} style={{aspectRatio: "1/1", overflow: "hidden", width: "64.40%", position: "absolute", top: `18.82%`, left: `19.6%`}}>
                                    <img style={{maxWidth: `${scale}%`, position: "absolute", top: `0`, left: `0`, width: `${scale}%`, height: `${scale}%`, zIndex: 0, objectFit: "cover", objectPosition: `${-xOffset}px ${-yOffset}px`}} src={filePreview} alt={"Your Face"}/>
                                </div>}
                                <div>
                                    <Grid container direction={"column"} style={{width: "80%", position: "absolute", top: `74.97%`, left: `10%`, zIndex: 2}}>
                                        <Grid item>
                                            <SamaggiTypography style={{color: "#ffffff", fontSize: "1.24rem", fontFamily: "SoleilLight"}} center>{firstName} {lastName}</SamaggiTypography>
                                        </Grid>
                                    </Grid>
                                    <Grid container direction={"column"} style={{width: "80%", position: "absolute", top: `62.78%`, left: `10%`, zIndex: 2}}>
                                        <Grid item>
                                            <SamaggiTypography style={{color: "rgb(254, 239, 221)", fontSize: "3.6rem", fontFamily: "SoleilBook"}} center>{nickname.toUpperCase()}</SamaggiTypography>
                                        </Grid>
                                    </Grid>
                                    <Grid container direction={"column"} style={{width: "80%", position: "absolute", top: `81.12%`, left: `10%`, zIndex: 2}}>
                                        <Grid item>
                                            <SamaggiTypography style={{color: "rgb(202, 209, 126)", fontSize: "0.6rem", fontFamily: "SoleilRegular"}} center>{role.toUpperCase()}</SamaggiTypography>
                                        </Grid>
                                    </Grid>
                                </div>
                                <img style={{maxWidth: "100%", position: "relative", zIndex: 1}} src={lanyardTemp} alt={"Lanyard Template"}/>
                            </div>
                        </Grid>
                        <Grid item container direction={"column"}>
                            <Grid item>
                                <SamaggiSlider label="Horizontal Offset" defaultValue={0} max={100} min={0} value={xOffsetPct} onChange={(_, val) => valChanged("x", val as number)}/>
                            </Grid>
                            <Grid item>
                                <SamaggiSlider label="Vertical Offset" defaultValue={0} max={100} min={0} value={yOffsetPct} onChange={(_, val) => valChanged("y", val as number)}/>
                            </Grid>
                            <Grid item>
                                <SamaggiSlider label="Zoom" defaultValue={100} max={400} min={100} value={scale} onChange={(_, val) => valChanged("s", val as number)}/>
                            </Grid>
                        </Grid>
                    </SamaggiFormSection>
                </Grid>
                <Grid item container direction={"column"} spacing={2}>
                    <Grid item>
                        <SamaggiButton fullWidth onClick={() => uploadFile()}>{submitText}</SamaggiButton>
                    </Grid>
                    <Grid item>
                        <SamaggiButton fullWidth colour={Colours.gray} hoverColour={Colours.darkGray} onClick={() => navigate("/")}>Back</SamaggiButton>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )

}
